module.exports = __webpack_public_path__ + "img/intro3.9231c20f.png";